import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { Injectable } from '@angular/core';
import { CommonService } from '@tech-services/common.service';
import { SessionService } from './session.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class LoginGuardian implements CanActivate {
  constructor(
    private commonService: CommonService,
    private session: SessionService,
    private router: Router,
    private translate: TranslateService
  ) {}

  canActivate(router: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (
      this.session.sessionToken === null ||
      this.session.sessionToken === undefined ||
      this.session.sessionToken === ''
    ) {
      this.router.navigate(['/login']);
      return false;
    } else {
      if (
        this.commonService.getClientData().subscribe(
          (data) => {
            this.session.clientData = data;
            this.commonService.clientDataInitialSource.next(data);
            this.session.clientCode = data.Code;
            if (
              data.Language &&
              !this.commonService.forcedLanguageSource.getValue() &&
              !localStorage.getItem('MainSettings')
            ) {
              this.translate.use(data.Language);
              this.session.language = data.Language;
              localStorage.setItem('Language', data.Language);
            }
            return true;
          },
          (err) => {
            if (err.status !== 401) {
              this.router.navigate(['/login']);
            } else {
              this.commonService.errorManager(err.error, err);
            }
            return false;
          }
        )
      ) {
        return true;
      } else {
        return false;
      }
    }
  }
}
